import { FieldProps } from "@rjsf/utils";
import DateTimePickerInput from "@/components/Inputs/DateTimePickerInput/DateTimePickerInput";
import dayjs from "dayjs";

const DateTimeWidget = (props: FieldProps) => {
  const { value, onChange } = props;

  // Convert the string value to dayjs object for the DateTimePickerInput
  const dayjsValue = value ? dayjs(value) : null;

  const handleChange = (newValue: dayjs.Dayjs | null) => {
    if (newValue) {
      // Convert dayjs back to ISO string for the form data
      onChange(newValue.toISOString());
    } else {
      onChange(undefined);
    }
  };

  return (
    <DateTimePickerInput
      inputLabel=""
      startFromTimePickerValue={dayjsValue}
      handleChange={handleChange}
      disabled={props.disabled}
    />
  );
};

export default DateTimeWidget;
